<div class="modal-header pricing-modal">
  <h4 class="modal-title">{{type === 'add' ? 'Add Payment Info' : 'Edit Payment Info'}}</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="col-12">
    <div class="row justify-content-md-center no-gutters">
      <div class="col-12">
        <form [formGroup]="pricingForm" (ngSubmit)="save()">
          <!-- Row 1: Date, PPP, Number of users, Chargeback -->
          <div *ngIf="!isOpenPricing" class="row">
            <div class="col-3">
              <label for="DateOfPurchase">Date of purchase</label>
              <input type="text" class="form-control" id="DateOfPurchase" name="DateOfPurchase"
                     formControlName="DateOfPurchase" />
            </div>
            <div class="col-3">
              <label for="PricePerPerson">Price per Person (PPP)</label>
              <input type="number" min="0" class="form-control" id="PricePerPerson" name="PricePerPerson" (change)="onPriceChange($event)"
                     formControlName="PricePerPerson" (keypress)="validateChargeBackFields($event, true)"
                     [ngClass]="pricingForm.controls['PricePerPerson'].hasError('pattern') ? 'ErrorFieldBorder' : ''" />
            </div>
            <div class="col-3">
              <label for="NoOfUsers">Number of users<span class="mandatoryMark">*</span></label>
              <input type="number" [attr.min]="minNumberOfUsers" class="form-control" id="NoOfUsers" name="NoOfUsers" (change)="onNoOfUsersChange($event);validateNumberOfUser()" (keypress)="acceptPositiveNumberInput($event);validateNumberOfUser();"
                     (paste)="acceptPositiveNumberInput($event);validateNumberOfUser();"
                     formControlName="NoOfUsers" [ngClass]="(pricingForm.controls['NoOfUsers'].hasError('required') || invalidNumberOfUsers) && isSubmitted ? 'ErrorFieldBorder' : ''" />
              <div class="marTop">
                <span class="error-message" *ngIf="invalidNumberOfUsers">Minimum of 100 and above</span>
              </div>
            </div>
            <div class="col-3">
              <label for="ChargeBack">Chargeback</label>
              <div class="form-group chargeback">
                <input class="form-control" type="text" id="ChargeBack" placeholder="No. of users * PPP" formControlName="ChargeBack" [disabled]="true" />
              </div>
            </div>
          </div>
          <!-- Row 2: Do not integrate checkbox, Reason, SF Unique Id, Event Name -->
          <div *ngIf="!isOpenPricing" class="row">
            <ng-container *ngIf="showPrepaidSfdcControls">
              <div class="col-3">
               
                <label for="disableSFDCIntegration" class="form-check-label mb-0">Do not integrate with Salesforce</label>
                 <div class="form-check form-check-inline d-flex align-items-center" style="min-height: 38px;">
                  <input id="disableSFDCIntegration" type="checkbox" class="form-check-input mr-2" formControlName="DisableSFDCIntegration" />
                </div>
              </div>
              <div class="col-3 reasonMargin" *ngIf="pricingForm.get('DisableSFDCIntegration').value">
                <label for="SFDCDisableReasonId">Reason <span class="mandatoryMark">*</span></label>
                <div class="form-group mb-0">
                  <select id="SFDCDisableReasonId" class="form-control custom-select" formControlName="SFDCDisableReasonId"
                          [ngClass]="{ 'ErrorFieldBorder': isSubmitted && pricingForm.get('SFDCDisableReasonId').invalid }">
                    <option [ngValue]="null" hidden disabled selected>Select</option>
                    <option *ngFor="let sfdcDisableReason of sfdcDisableReasons" [value]="sfdcDisableReason.ID">
                      {{sfdcDisableReason.Reason}}
                    </option>
                  </select>
                  <i class="fa fa-chevron-down"></i>
                </div>
              </div>
            </ng-container>
            <div class="col-3">
              <label for="EventID">SF Unique Id</label>
              <input id="EventID" type="text" class="form-control" name="EventID" formControlName="EventID" />
            </div>
            <div class="col-3">
              <label for="EventName">Event Name
                <a *ngIf="eventLink && eventIdValue" [href]="eventLink + eventIdValue" target="_blank" class="ml-2">
                  <i class="fa fa-external-link"></i>
                </a>
              </label>
              <input id="EventName" type="text" class="form-control" name="EventName" formControlName="EventName" />
            </div>
          </div>

          <!-- Other reason (only when Reason = 4) -->
          <div *ngIf="showPrepaidSfdcControls && pricingForm.get('DisableSFDCIntegration').value && +pricingForm.get('SFDCDisableReasonId').value === 4" class="row">
            <div class="col-3 offset-3">
              <label for="SFDCDisableOtherReason">Other reason <span class="mandatoryMark">*</span></label>
              <input type="text" class="form-control" id="SFDCDisableOtherReason" 
                     formControlName="SFDCDisableOtherReason"
                     (focusout)="onFocusOutOtherReason()"
                     (input)="validateSFDCDisableOtherReason()"
                     [ngClass]="{ 'ErrorFieldBorder': isSubmitted && (pricingForm.get('SFDCDisableOtherReason').invalid || isSFDCDisableOtherReasonInvalid) }" />
              <span class="error-message inline-error"
                    *ngIf="isSubmitted && (pricingForm.get('SFDCDisableOtherReason').invalid || isSFDCDisableOtherReasonInvalid)">
                {{sfdcDisableOtherReasonInvalidMessage}}
              </span>
            </div>
          </div>
          <div *ngIf="isOpenPricing" class="row">
            <div class="col-4">
              <label for="StartDate">Subscription Start Date<span class="mandatoryMark">*</span></label>
              <input type="text" class="form-control" id="StartDate" name="StartDate"
                     formControlName="StartDate" />
            </div>
            <div class="col-4">
              <label for="EndDate">Subscription End Date<span class="mandatoryMark">*</span></label>
              <input type="text" class="form-control" id="EndDate" name="EndDate"
                     formControlName="EndDate" />
            </div>
            <div class="col-4">
              <label for="PricePerPersonOpenPricing">Price per person (PPP)</label>
              <input type="number" class="form-control" id="PricePerPersonOpenPricing" name="PricePerPerson" min="0" (change)="onPriceChange($event)" (keypress)="validateChargeBackFields($event, true)"
                     formControlName="PricePerPerson" />
            </div>
          </div>
          <div *ngIf="isOpenPricing" class="row">
            <div class="col-4">
              <label for="ChargeBackOpenPricing">Chargeback</label>
              <input type="text" class="form-control" id="ChargeBackOpenPricing" name="ChargeBack"
                     formControlName="ChargeBack" />
            </div>
            <div class="col-4">
              <label for="ActualUsage">Actual Usage</label>
              <input type="text" class="form-control" id="ActualUsage" name="ActualUsage"
                     formControlName="ActualUsage" />
            </div>
          </div>
          <div>
            <div *ngIf="WBSCodesList" formArrayName="WBSCodesList">
              <label for="multiplWBS">WBS<span *ngIf="sponsoringCountry == 23" class="mandatoryMark">*</span></label>
              <div class="row" id="multiplWBS" *ngFor="let wbsCode of WBSCodesList.controls;let i = index" [formGroupName]="i">
                <div class="col-4 position-relative">
                  <input type="text" class="form-input textTransform SubWBSText" placeholder="WBS" formControlName="wbscode" (keyup)="checkWbsCodesErrors(WBSCodesList.controls,'chargeback'); onWBSValueChange(i, false)" (change)="enableDisableAddWbsCode()"
                        [ngbTypeahead]="getWbsCodeSearch(i, false)"
                         [resultFormatter]="formatWBS"
                         (selectItem)="onWBSSelect($event, i, false)"
                         [ngClass]="
                                    ( (pricingForm.get('WBSCodesList').get(i.toString()).get('wbscode').hasError('required') && isSubmitted)
                                    || pricingForm.get('WBSCodesList').get(i.toString()).get('wbscode').hasError('pattern')
                                    || pricingForm.get('WBSCodesList').get(i.toString()).get('wbscode').hasError('isEmpty')
                                    || pricingForm.get('WBSCodesList').get(i.toString()).get('wbscode').hasError('notPickedFromList') ) ? 'ErrorFieldBorder' : ''
                                  " />
                  <!-- Show "searching..." while API call is happening -->
                  <span *ngIf="isWbsRowSearching(i, false) && pricingForm.get('WBSCodesList').get(i.toString()).get('wbscode').value" class="wbs-loading-spinner">
                    <i class="fa fa-spinner fa-spin"></i> Searching...
                  </span>

                  <!-- Show green tick if WBS is selected from picklist and not modified -->
                  <span *ngIf="pricingForm.get('WBSCodesList').get(i.toString()).get('wbscode').value && WBSCodesList.at(i)['isSelectedFromPicklist'] && WBSCodesList.at(i)['isWbsActive']"
                        class="wbs-success-icon" title="WBS Code is active">
                    <i class="fa fa-check-circle"></i>
                  </span>

                  <!-- Show grey tick if WBS is invalid (no longer active) and was from edit data -->
                  <span *ngIf="pricingForm.get('WBSCodesList').get(i.toString()).get('wbscode').value && WBSCodesList.at(i)['isWbsStatusChecked'] && !WBSCodesList.at(i)['isWbsActive'] && WBSCodesList.at(i)['isExistingWbs']"
                        class="wbs-success-icon wbs-success-icon--inactive" title="Code(s) is no longer active">
                    <i class="fa fa-check-circle"></i>
                  </span>
                </div>
                <div class="col-4 please-specify">

                  <input *ngIf="WBSCodesList.controls.length > 1" type="text" class="form-input" placeholder="Please Specify % Split" formControlName="Description"
                         [ngClass]="!isPercentageSplit100 && isSubmitted ? 'ErrorFieldBorder' : ''" (change)="enableDisableAddWbsCode()" (keyup)="checkPercentage(WBSCodesList.controls,'chargeback')" (keypress)="allowNumbersOnly($event)" />

                </div>
                <span *ngIf="WBSCodesList.controls.length>1" class="percent">%</span>

                <a *ngIf="i === WBSCodesList.controls.length-1 && i !== 0 && !(isSubscriptionCreatedBeforeMdmWbsDeploymentDate && WBSCodesList.at(i)['isExistingWbs'] && !WBSCodesList.at(i)['isWbsActive'])" class="remove-link" (click)="removeWbsCode(i)">Remove</a>
              </div>
              <div class="col-4 pad0">
                <span id="wbs_info_text">Enter a chargeable 22- character code (e.g., ZYW12345-01-01-01-0000). New code(s) may take few hours to appear; save as draft and retry later.</span>
              </div>
              <div>
                <button type="button" [ngClass]="isAddWbsCodes ? 'add-button' : 'disable-add-button'" (click)="addWbsCodes()" [disabled]="!isAddWbsCodes">Add</button>
              </div>
            </div>
          </div>

          <div>
            <div *ngIf="isEditMode && this.editData && this.editData['Surcharge'] && +this.editData['Surcharge'] > 0 && SurchargeWBSCodesList" formArrayName="SurchargeWBSCodesList">
              <label class="surcharge">Surcharge</label>
              <div class="row" id="multipleSurcharge"
                   *ngFor="let surChargeWbsCode of SurchargeWBSCodesList.controls;let i = index" [formGroupName]="i">
                <div class="col-4 position-relative">
                  <input type="text" class="form-input textTransform" placeholder="WBS" formControlName="wbscode" (change)="enableDisableSurchargeWbsCodes()" (keyup)="checkWbsCodesErrors(SurchargeWBSCodesList.controls,'surcharge'); onWBSValueChange(i, true)"
                        [ngbTypeahead]="getWbsCodeSearch(i, true)"
                         [resultFormatter]="formatWBS"
                         (selectItem)="onWBSSelect($event, i, true)"
                         [ngClass]="pricingForm.get('SurchargeWBSCodesList').get(i.toString()).get('wbscode').hasError('pattern') ||
                           pricingForm.get('SurchargeWBSCodesList').get(i.toString()).get('wbscode').hasError('isEmpty') ||
                           pricingForm.get('SurchargeWBSCodesList').get(i.toString()).get('wbscode').hasError('notPickedFromList') ? 'ErrorFieldBorder' : ''" />
                  <!-- Show "searching..." while API call is happening -->
                  <span *ngIf="isWbsRowSearching(i, true) && pricingForm.get('SurchargeWBSCodesList').get(i.toString()).get('wbscode').value" class="wbs-loading-spinner">
                    <i class="fa fa-spinner fa-spin"></i> Searching...
                  </span>

                  <!-- Show green tick if WBS is selected from picklist and not modified -->
                  <span *ngIf="pricingForm.get('SurchargeWBSCodesList').get(i.toString()).get('wbscode').value && SurchargeWBSCodesList.at(i)['isSelectedFromPicklist'] && SurchargeWBSCodesList.at(i)['isWbsActive']"
                        class="wbs-success-icon" title="WBS Code is active">
                    <i class="fa fa-check-circle"></i>
                  </span>

                  <!-- Show grey tick if WBS is invalid (no longer active) and was from edit data -->
                  <span *ngIf="pricingForm.get('SurchargeWBSCodesList').get(i.toString()).get('wbscode').value && SurchargeWBSCodesList.at(i)['isWbsStatusChecked'] && !SurchargeWBSCodesList.at(i)['isWbsActive'] && SurchargeWBSCodesList.at(i)['isExistingWbs']"
                        class="wbs-success-icon wbs-success-icon--inactive" title="Code(s) is no longer active">
                    <i class="fa fa-check-circle"></i>
                  </span>
                </div>
                <div class="col-4 please-specify">

                  <input *ngIf="SurchargeWBSCodesList.controls.length > 1" type="text" class="form-input" placeholder="Please Specify % Split" formControlName="Description" (keyup)="checkPercentage(SurchargeWBSCodesList.controls,'surcharge')"
                         [ngClass]="!isSurChargePercentageSplit100 && isSubmitted  ? 'ErrorFieldBorder' : ''" (change)="enableDisableSurchargeWbsCodes()" (keypress)="allowNumbersOnly($event)" />
                </div>
                <span *ngIf="SurchargeWBSCodesList.controls.length>1" class="percent">%</span>

                <a *ngIf="i === SurchargeWBSCodesList.controls.length-1 && i !== 0 && !(isSubscriptionCreatedBeforeMdmWbsDeploymentDate && SurchargeWBSCodesList.at(i)['isExistingWbs'] && !SurchargeWBSCodesList.at(i)['isWbsActive'])" class="remove-link" (click)="removeSurChargeWbsCode(i)">Remove</a>
              </div>
              <div class="col-4 pad0">
                <span id="wbs_info_text_surcharge">Enter a chargeable 22- character code (e.g., ZYW12345-01-01-01-0000). New code(s) may take few hours to appear; save as draft and retry later.</span>
              </div>
              <div>
                <button type="button" [ngClass]="isAddSurChargeWbsCodes ? 'add-button' : 'disable-add-button'" (click)="addSurchargeWbsCodes()" [disabled]="!isAddSurChargeWbsCodes">Add</button>
              </div>
            </div>
          </div>
        </form>
      </div>

    </div>
  </div>

</div>
<div *ngIf="isSurchargeFormatError || isWbsFormatError ||isDuplicateWbsCodes || isDuplicateSurchargeWbsCodes" class="error-message">Please enter valid WBS code</div>
<div *ngIf="(!isPercentageSplit100 || !isSurChargePercentageSplit100) && isSubmitted" class="error-message">Make sure you've entered a % split for each code that adds up to 100</div>
<div *ngIf="isWBSMandatory && isStatusActive && isWbsInactive" class="error-message">Code(s) is no longer active</div>
<div *ngIf="isWBSMandatory && wbsNotPickedFromList" class="error-message">WBS must be selected from the list</div>
<div *ngIf="((pricingForm.controls['NoOfUsers'] && pricingForm.controls['NoOfUsers'].hasError('required'))|| (pricingForm.controls['WBSCodesList'] && pricingForm.controls['WBSCodesList'].hasError('required')) ) && isSubmitted" class="error-message">Please complete all required/mandatory fields (*).</div>
<div *ngIf="hasValidWBSCodes() && !IsWBSCodeConfirmed && isSubmitted" class="error-message">Please confirm the WBS code.</div>
<!-- WBS Code Confirmation Checkbox -->
<div *ngIf="hasValidWBSCodes()" class="wbs-confirmation-section">
  <div class="form-check wbs-check">
    <input class="form-check-input" type="checkbox" id="confirmWbsCode"
           [(ngModel)]="IsWBSCodeConfirmed" name = "IsWBSCodeConfirmed" (change)="onWbsConfirmationChange($event)"  />
    <label class="form-check-label" for="confirmWbsCode">
      I acknowledge the entered code is accurate and can be used.
    </label>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="clickBtn" (click)="save()" [disabled]="hasValidWBSCodes() && !IsWBSCodeConfirmed">Save</button>
  <button type="button" class="clickBtn" (click)="activeModal.dismiss('Cross click')">Cancel</button>
</div>
